import { Redirect, useLocation, useParams } from 'lib/router'
import { useEffect } from 'react'

type Params = {
  onboardingRecordId: string
}

export const OnboardingGateContainer = () => {
  useEffect(() => {
    document.body.classList.add('off-white-background')
    return () => {
      document.body.classList.remove('off-white-background')
    }
  })
  const { onboardingRecordId } = useParams<Params>()
  const { search } = useLocation()
  const redirectPath = !!onboardingRecordId
    ? `/welcome/${onboardingRecordId}`
    : '/welcome'

  return <Redirect to={{ pathname: redirectPath, search }} />
}
